import { Identifiable } from 'app/armp/models/identifiable';

export class Profile extends Identifiable<number> {
  name: string;
  description: string;
  roles: number[];
  system: boolean;
}
